export default function capitalize(s)
{
    if(!s) return null;
    return s[0].toUpperCase() + s.slice(1);
}